import React from "react";

function AboutLeftArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 38 61"
    >
      <path
        stroke="#AAEAC8"
        strokeWidth="10"
        d="M34 4L4 34m0-7.071l30 30"
      />
    </svg>
  );
}

export default AboutLeftArrow;
